import { makeAutoObservable } from 'mobx';
import { SubscriptionEnum, SubscriptionSourceEnum, UserRoleEnum } from '@app/common';
import { ExternalTypeEnum, LookupKeyEnum, SourceSurveyEnum, UserProfileDto } from '../../../../defs/api';

export class UserProfileMobxDto implements UserProfileDto {
    public id: string = '';

    public email: string = '';

    public isOnWaitingList: boolean = false;

    public fullName: string = '';

    public nickname: string = '';

    public role: UserRoleEnum = UserRoleEnum.User;

    public newsletter: boolean = false;

    public subscription: SubscriptionEnum = SubscriptionEnum.Free;

    public scheduledSubscription?: SubscriptionEnum | null = null;

    public subscriptionSource: SubscriptionSourceEnum = null as never;

    public lookupKey?: LookupKeyEnum;

    public subscriptionEndDate: Date | null = null;

    public hadTrialing: boolean = false;

    public interestedInSubscription: LookupKeyEnum | null = null;

    public zendeskToken?: string;

    public agreedTerms: boolean = false;

    public externalType?: ExternalTypeEnum;

    public sourceSurvey: SourceSurveyEnum | null = null;

    constructor() {
        makeAutoObservable(this, {});
    }

    static create(dto: UserProfileDto): UserProfileMobxDto {
        const mobxDto = new UserProfileMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: UserProfileDto[]): UserProfileMobxDto[] {
        return dtos.map((dto) => UserProfileMobxDto.create(dto));
    }

    get isAdmin(): boolean {
        return this.role === UserRoleEnum.Admin;
    }
}
